/**
 * Provides a backbone wrapper over the `esri.dijit.Search` control.
 * ## Fields
 * Name | Description
 * --- | ---
 * geocoder | The underlying `esri.dijit.Search`. Only available after the render operation.
 *
 * ## Events
 * Name | Arguments | Description
 * --- | --- | ---
 * select | The name of the selected location and an `esri.geometry.Point` representing the location. | Fires whenever a search result is selected.
 * @module app/views/map/MapSearchView
 */
import Backbone from "backbone";
import _ from "underscore";
import $ from "jquery";

var MapSearchView = Backbone.View.extend({
  template: _.template(
    '<div class="map-search"><div class="map-search-input"></div></div>'
  ),

  className: "map-search-container",

  initialize: function (options) {
    this.options = _.defaults({}, options);
  },

  render: function () {
    var Search = window.require("esri/dijit/Search");

    this.$el.html(this.template(this.options));
    this.$el.on(
      "keypress",
      _.bind(function (evt) {
        if (evt.which == 13) {
          //13 is enter key
          $("form").one("submit", function (fEvt) {
            fEvt.preventDefault();

            return false;
          });
        }
      }, this)
    );

    this.geocoder = new Search(
      {
        enableButtonMode: true,
        addLayersFromMap: false,
        enableInfoWindow: false,
        map: this.options.map,
      },
      this.getInput()[0]
    );
    this.geocoder.startup();

    /*if(layer.serviceLayer && layer.serviceLayer.service.get('external')){
		 var sources = self._searchView.geocoder.get('sources');

		 sources.push({
		 featureLayer: layer.getMapLayer(),
		 searchFields: [layer.getDisplayNameField().id],
		 displayField: layer.getDisplayNameField().id,
		 name: layer.name,
		 maxResults: 1000
		 });
		 self._searchView.geocoder.set('sources', sources);
		 self._searchView.geocoder.set('enableSourcesMenu', true);
		 self._searchView.geocoder.startup();
		 }*/

    /*this.geocoder.on('select-result', _.bind(function(evt){
		 var point = evt.result.feature.geometry;
		 var name = evt.result.name;                        

		 this.trigger('select', name, point);
		 }, this));        */
  },

  /**
   * Gets the input control associated with this view.
   * @return {jquery} The input control.
   */
  getInput: function () {
    return this.$(".map-search-input");
  },

  /**
   * Gets the id of the input control associated with this view.
   * @return {string} The element id.
   */
  getInputId: function () {
    var $input = this.getInput();

    $input.attr("id", $input.attr("id") || _.uniqueId("el"));

    return $input.attr("id");
  },
});

export default MapSearchView;



//////////////////
// WEBPACK FOOTER
// ./public/js/app/views/map/MapSearchView.js
// module id = 951
// module chunks = 1